var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#00C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04468 14.125V5.72501H10.1647C10.7567 5.72501 11.2807 5.84101 11.7367 6.07301C12.1927 6.30501 12.5487 6.62501 12.8047 7.03301C13.0607 7.43301 13.1887 7.90101 13.1887 8.43701C13.1887 8.96501 13.0527 9.43701 12.7807 9.85301C12.5167 10.261 12.1527 10.581 11.6887 10.813C11.2247 11.037 10.6967 11.149 10.1047 11.149H8.68868V14.125H7.04468ZM11.6647 14.125L9.72068 10.753L10.9807 9.85301L13.5247 14.125H11.6647ZM8.68868 9.64901H10.1767C10.4247 9.64901 10.6447 9.59701 10.8367 9.49301C11.0367 9.38901 11.1927 9.24501 11.3047 9.06101C11.4247 8.87701 11.4847 8.66901 11.4847 8.43701C11.4847 8.07701 11.3527 7.78501 11.0887 7.56101C10.8327 7.33701 10.5007 7.22501 10.0927 7.22501H8.68868V9.64901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestStopIcon);
export default __webpack_public_path__ + "static/media/rest_stop_icon.5a1d3d39647dc49c6d40df15126d96e0.svg";
export { ForwardRef as ReactComponent };